import React from "react";

const HomologBanner = () => {
  if (process.env.REACT_APP_ENV !== "homolog") return null;
  return (
    <div
      role="note"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        // Escala do DS (§5): acima do modal (400). O toast também é 500 e vem
        // depois no DOM (App.js), então fica por cima da faixa no celular.
        zIndex: "var(--care-z-toast)",
        // Atenção (amber) do DS v3; o texto diz o ambiente, a cor só reforça.
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "var(--care-space-9)", // 32px = paddingTop do App em homolog
        backgroundColor: "var(--care-warning-bg)",
        color: "var(--care-warning-text)",
        borderBottom: "var(--care-border-hairline) solid var(--care-warning-border)",
        textAlign: "center",
        padding: "0 var(--care-space-6)",
        fontSize: "var(--care-text-sm)",
        fontWeight: "var(--care-weight-semibold)",
        letterSpacing: "var(--care-tracking-caption)",
        fontFamily: "var(--care-font-sans)",
      }}
    >
      Ambiente de homologação · dados de teste — não usar para decisões reais
    </div>
  );
};

export default HomologBanner;
